var DialogPriceData = /** @class */ (function () {
    function DialogPriceData() {
        this.allPricePerPax = [];
        this.allDialogPriceData = [];
        this.summaryPriceData = [];
        this.floatInside = false;
        this.additionalFloatInside = false;
        this.totalPrice = 0;
        // @toDo
    }
    DialogPriceData.prototype.setFloatInside = function (floatInside) {
        this.floatInside = floatInside;
    };
    DialogPriceData.prototype.getFloatInside = function () {
        return this.floatInside;
    };
    DialogPriceData.prototype.addPricePerPaxData = function (dialogPaxPriceDataItem) {
        this.allPricePerPax.push(dialogPaxPriceDataItem);
    };
    DialogPriceData.prototype.getPricePerPaxData = function () {
        return this.allPricePerPax;
    };
    DialogPriceData.prototype.setAdditionalFloatInside = function (floatInside) {
        this.additionalFloatInside = floatInside;
    };
    DialogPriceData.prototype.getAdditionalFloatInside = function () {
        return this.additionalFloatInside;
    };
    DialogPriceData.prototype.addDialogPriceData = function (name, dialogPriceDataItem) {
        this.allDialogPriceData[this.allDialogPriceData.length] = dialogPriceDataItem;
    };
    DialogPriceData.prototype.addSummaryPriceData = function (name, dialogPriceDataItem) {
        this.summaryPriceData[this.summaryPriceData.length] = dialogPriceDataItem;
    };
    DialogPriceData.prototype.getAllDialogPriceData = function () {
        return this.allDialogPriceData;
    };
    DialogPriceData.prototype.getSummaryPriceData = function () {
        return this.summaryPriceData;
    };
    DialogPriceData.prototype.setTotalPrice = function (totalPrice) {
        this.totalPrice = totalPrice;
    };
    DialogPriceData.prototype.getTotalPrice = function () {
        return this.totalPrice;
    };
    return DialogPriceData;
}());
export { DialogPriceData };
export default DialogPriceData;
